import BaseUtil from "../../../util/BaseUtil";
import UserTypeUtil from "../../../util/UserTypeUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    itemsEnabledFinding: true, // 字段是否启用
    initializing: true,
    clothesTypeArray: [],
    clothesType: null,

    selectedUnitIds: null, // 选中科室ids
    selectedUserTypes: UserTypeUtil.getAllUserTypeCodes(),
    unitsMap: null,
    tableLoading: false, // 表格加载
    tableData: null, // 表格数据
    singleUnitTableData: null, // 单科室表格数据

    clothesDicts: null, // 鞋衣帽对应字典

    // 点击单元格
    detailDrawerVisible: false, // 详情可见
    detailDrawerData: null, // 详情数据
    detailDrawerLoading: false, // 详情加载
    clickedCell: {
        unitId: null, // 点击查看详情的科室
        option: null, // 点击查看详情的字典
        title: null, // 点击查看详情的标题
    },
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
